import { ComingSoonBadge } from '@/lib';
import { FC, ReactNode } from 'react';

type ComingSoonDestinationItemProps = {
  name: string;
  icon: ReactNode;
};

export const ComingSoonDestinationItem: FC<ComingSoonDestinationItemProps> = ({ name, icon }) => {
  return (
    <div className='flex min-h-[14.125rem] min-w-80 cursor-not-allowed flex-col gap-3 rounded-xl border bg-white-100 p-4'>
      {icon}
      <p className='font-semibold'>{name}</p>
      <div className='flex grow items-end justify-end'>
        <ComingSoonBadge />
      </div>
    </div>
  );
};
